export const CustomIcons = ({ icon: Icon, style: styles}) => {
  return (
    <Icon
      style={ styles ? styles : {}}
    />
  );
};
